module.exports = __webpack_public_path__ + "img/IMG_4516.1db37df5.jpg";